import { Form } from '@themesberg/react-bootstrap'
import { DATE_CONSTANTS } from './dateConstants'
import React from 'react'
import { getDateDaysAgo } from '../../utils/dateFormatter'

const defaultDateRange = [{
  startDate: getDateDaysAgo(0),
  endDate: new Date(),
  key: 'selection'
}]

export default ({
  dateOptions,
  setDateOptions,
  setDateRange
}) => {
  return (
    <>
      <Form.Select
        onChange={(e) => {
          setDateOptions(e.target.value)
          // Custom date range should be reset when selecting a pre-defined range. e.g. - yesterday
          setDateRange && setDateRange(defaultDateRange)
        }}
        value={dateOptions}
        style={{ width: 'auto', marginRight: '10px' }}
        size='sm'
      >
        {DATE_CONSTANTS.map(({ label, value }) =>
          <option value={value} key={value}>{label}</option>
        )}
      </Form.Select>
    </>
  )
}
